/* sk8 Monster Drops, tema 360, gaveta.js.
   A gaveta da sacola (carrinho lateral,
   snippets/gaveta.liquid): abre pela direita ao adicionar um item
   (produto.js chama SK8.abrirGaveta com a sacola ja atualizada) e pelo icone
   da sacola no HUD (a[data-sacola]; sem JS o icone segue para /cart).
   Desenha os itens a partir de /cart.js, muda quantidade e remove por
   /cart/change.js e atualiza o medidor do HUD (SK8.atualizarSacola). Fundo
   escurecido, Esc e toque fora fecham; foco preso dentro enquanto aberta.
   "Finalizar compra" e um form do proprio snippet, igual ao da pagina /cart.
   Carrega em toda pagina pelo layout, depois de base.js (usa SK8.$, SK8.$$,
   SK8.som, SK8.atualizarSacola, SK8.rotas). Expoe SK8.abrirGaveta(sacola,
   origem), SK8.fecharGaveta() e SK8.recarregarGaveta().
   Sons do tema 360: abrir toca "menu" (menos logo depois de adicionar um item,
   quando o produto.js ja tocou "guardar"); fechar toca "voltar".
   17/10/2026: depois de cada alteracao a sacola e relida em /cart.js (o corpo do
   change.js tem outro formato e a chave do item muda com o desconto do Niver); o item
   e achado pela linha e pela variante, nunca pela chave; o resumo mostra soma das pecas,
   cada desconto e total; faixa "Falta 1 camiseta para 10% de desconto" quando as faixas
   valem (Niver inativo); cupom escondido no Niver e a partir de 2 pecas. */
(function () {
  "use strict";

  var SK8 = window.SK8 || {};
  var $ = SK8.$ || function (s, r) { return (r || document).querySelector(s); };
  var $$ = SK8.$$ || function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var Som = SK8.som || { tocar: function () {} };
  var gaveta = $("#gaveta"), fundo = $("[data-gaveta-fundo]");
  if (!gaveta || !fundo || !window.fetch) return;

  var rotas = SK8.rotas || { sacola: "/cart" };
  var lista = $("[data-gaveta-lista]", gaveta), vazia = $("[data-gaveta-vazia]", gaveta);
  var carregando = $("[data-gaveta-carregando]", gaveta), aviso = $("[data-gaveta-aviso]", gaveta);
  var subtotal = $("[data-gaveta-subtotal]", gaveta), contagem = $("[data-gaveta-contagem]", gaveta);
  var caixaDescontos = $("[data-gaveta-descontos]", gaveta), rotuloTotal = $("[data-gaveta-rotulo-total]", gaveta);
  var meta = $("[data-gaveta-meta]", gaveta), metaTexto = $("[data-gaveta-meta-texto]", gaveta), metaBarra = $("[data-gaveta-meta-barra]", gaveta);
  var cupom = $("[data-gaveta-cupom]", gaveta);
  var sacola = null, pedido = null, aberta = false, ocupado = false, origem = null, tempoFechar = 0;

  var MENOS = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2.5 7h9"/></svg>';
  var MAIS = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M7 2.5v9M2.5 7h9"/></svg>';

  function dinheiro(c) {
    var n = Math.round(Number(c) || 0), reais = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var cent = String(n % 100);
    return "R$ " + reais + "," + (cent.length < 2 ? "0" + cent : cent);
  }
  function esc(t) {
    return String(t == null ? "" : t).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  // o nome curto e o que esta entre aspas no titulo (ou o titulo sem o prefixo), igual a pagina /cart
  function nomeCurto(t) {
    var p = String(t || "").split('"');
    return p.length > 2 ? p[1] : String(t || "").replace(/^Camiseta unissex 100% algod[aã]o\s*/i, "");
  }
  function somaDescontoItem(item) {
    return (item.discounts || []).reduce(function (s, d) { return s + (Number(d.amount) || 0); }, 0);
  }
  // preco da linha como a pessoa paga: o final da Shopify pode vir sem o desconto da sacola inteira
  function liquidoDoItem(item) { return (Number(item.original_line_price) || 0) - somaDescontoItem(item); }
  function rotuloDesconto(t) { return /^[A-Z0-9_-]{4,}$/.test(t) ? "Desconto " + t : t; }
  function descontosDaSacola(c) {
    var mapa = {}, ordem = [];
    (c.items || []).forEach(function (it) {
      (it.discounts || []).forEach(function (d) {
        var t = d.title || "Desconto";
        if (!(t in mapa)) { mapa[t] = 0; ordem.push(t); }
        mapa[t] += Number(d.amount) || 0;
      });
    });
    var lista = ordem.map(function (t) { return { titulo: t, valor: mapa[t] }; }).filter(function (x) { return x.valor > 0; });
    var total = Number(c.total_discount) || 0;
    if (!lista.length && total > 0) {
      var apps = (c.cart_level_discount_applications || []).filter(function (d) { return d.total_allocated_amount > 0; });
      lista = apps.length ? apps.map(function (d) { return { titulo: d.title, valor: d.total_allocated_amount }; }) : [{ titulo: "Desconto", valor: total }];
    }
    return lista;
  }
  // promocao de aniversario ativa agora? (mesmo JSON que o tema grava no <head>)
  function niverAgora() {
    try {
      var el = document.getElementById("sk8-promocao-aniversario");
      if (!el) return 0;
      var d = JSON.parse(el.textContent), pct = parseFloat(d.percentual) || 0, fim = d.termina_em ? Date.parse(d.termina_em) : 0;
      return pct > 0 && pct < 100 && fim > Date.now() ? pct : 0;
    } catch (e) { return 0; }
  }
  function pctTexto(n) { return String(n).replace(".", ","); }
  function miniatura(url) { return url ? url + (url.indexOf("?") < 0 ? "?" : "&") + "width=160" : ""; }
  function detalhe(item) {
    if (item.product_has_only_default_variant) return "";
    var o = item.options_with_values || [];
    if (o.length) return o.map(function (x) { return x.name + ": " + x.value; }).join(", ");
    return item.variant_title || "";
  }

  function mostrarAviso(texto) { aviso.textContent = texto || ""; aviso.hidden = !texto; }

  /* faixa de desconto por quantidade: so vale fora do Niver (o Niver nao soma com as faixas) */
  function desenharMeta(n, c, niver) {
    if (!meta) return;
    var f2 = Number(gaveta.getAttribute("data-faixa-2")) || 10, f3 = Number(gaveta.getAttribute("data-faixa-3")) || 15;
    var aplicado = (Number(c.total_discount) || 0) > 0;
    var texto = "", cheio = 0;
    if (n < 1) { meta.hidden = true; return; }
    if (niver) {
      texto = "Niver do Vini: " + pctTexto(niver) + "% já aplicado";
    } else if (n === 1) {
      texto = "Falta 1 camiseta para " + f2 + "% de desconto"; cheio = 33;
    } else if (n === 2) {
      texto = (aplicado ? "Você já tem " + f2 + "% de desconto. " : "") + "Falta 1 camiseta para " + f3 + "% de desconto"; cheio = 66;
    } else if (aplicado) {
      texto = "Você tem " + f3 + "% de desconto"; cheio = 100;
    } else { meta.hidden = true; return; }
    metaTexto.textContent = texto;
    meta.classList.toggle("niver", !!niver);
    meta.classList.toggle("completo", cheio === 100);
    if (metaBarra) {
      metaBarra.hidden = !cheio;
      var fio = metaBarra.firstElementChild;
      if (fio) fio.style.width = cheio + "%";
    }
    meta.hidden = false;
  }

  function desenhar(c) {
    if (c) sacola = c;
    if (!sacola) return;
    var itens = sacola.items || [], n = sacola.item_count || 0;
    carregando.hidden = true;
    lista.innerHTML = itens.map(function (item, i) {
      var nome = nomeCurto(item.product_title), det = detalhe(item);
      var liquido = liquidoDoItem(item);
      var riscado = item.original_line_price > liquido ? "<s>" + dinheiro(item.original_line_price) + "</s>" : "";
      return '<li class="gaveta-item" data-chave="' + esc(item.key) + '" data-linha="' + (i + 1) + '" data-variante="' + esc(item.variant_id) + '" data-qtd-atual="' + item.quantity + '">' +
        '<a class="gaveta-foto" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
          (item.image ? '<img src="' + esc(miniatura(item.image)) + '" alt="" width="76" height="76">' : "") + "</a>" +
        '<a class="gaveta-nome" href="' + esc(item.url) + '" data-nav>' + esc(nome) + "</a>" +
        '<span class="gaveta-detalhe">' + esc(det) + "</span>" +
        '<span class="gaveta-preco">' + riscado + dinheiro(liquido) + "</span>" +
        '<div class="gaveta-qtd" role="group" aria-label="Quantidade de ' + esc(nome) + '">' +
          '<button type="button" data-qtd="-1" aria-label="Diminuir a quantidade" data-nav>' + MENOS + "</button>" +
          '<span aria-live="polite">' + item.quantity + "</span>" +
          '<button type="button" data-qtd="1" aria-label="Aumentar a quantidade" data-nav>' + MAIS + "</button>" +
        "</div>" +
        '<button type="button" class="gaveta-remover" data-remover aria-label="Remover ' + esc(nome) + (det ? ", " + esc(det) : "") + ', da sacola" data-nav>Remover</button>' +
      "</li>";
    }).join("");
    var tem = itens.length > 0;
    gaveta.classList.toggle("vazia", !tem);
    vazia.hidden = tem;
    lista.hidden = !tem;
    $$("[data-gaveta-cheia]", gaveta).forEach(function (el) { el.hidden = !tem; });
    // resumo: soma das pecas, cada desconto e o total, para a conta fechar na tela
    var descontos = descontosDaSacola(sacola);
    if (caixaDescontos) {
      caixaDescontos.innerHTML = descontos.length
        ? '<div class="gaveta-desconto"><span>Soma das peças</span><span>' + dinheiro(sacola.original_total_price) + "</span></div>" +
          descontos.map(function (d) { return '<div class="gaveta-desconto verde"><span>' + esc(rotuloDesconto(d.titulo)) + "</span><span>-" + dinheiro(d.valor) + "</span></div>"; }).join("")
        : "";
      caixaDescontos.hidden = !tem || !descontos.length;
    }
    if (rotuloTotal) rotuloTotal.textContent = descontos.length ? "Total" : "Subtotal";
    subtotal.textContent = dinheiro(sacola.total_price);
    contagem.textContent = n + (n === 1 ? " item" : " itens");
    var niver = niverAgora();
    desenharMeta(n, sacola, niver);
    // o cupom nao soma com o Niver nem com as faixas: some no Niver e a partir de 2 pecas
    if (cupom) cupom.hidden = !tem || !!niver || n >= 2;
  }

  function lerSacola() {
    return fetch(rotas.sacola + ".js", { headers: { Accept: "application/json" }, cache: "no-store" })
      .then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  // buscar() junta pedidos simultaneos (passar o mouse e abrir); fresca() sempre pergunta de novo, depois de uma alteracao
  function buscar() {
    if (!pedido) {
      pedido = lerSacola().then(function (c) { pedido = null; return c; }, function (e) { pedido = null; throw e; });
    }
    return pedido;
  }
  function recarregar(silencioso) {
    return lerSacola().then(function (c) {
      desenhar(c);
      if (SK8.atualizarSacola) SK8.atualizarSacola(c.item_count);
      return c;
    }).catch(function () {
      carregando.hidden = true;
      if (!silencioso) mostrarAviso("Não foi possível carregar a sacola. Verifique a sua conexão e tente novamente.");
    });
  }

  // ------------------------------------------------------------------ abrir e fechar
  function focaveis() {
    return $$('a[href]:not([tabindex="-1"]), button:not([disabled])', gaveta).filter(function (el) {
      return el.getClientRects().length > 0 && !el.closest("[hidden]");
    });
  }
  function abrir(c, deOnde) {
    origem = deOnde || document.activeElement;
    mostrarAviso("");
    if (c) desenhar(c);
    else if (!sacola) { carregando.hidden = false; lista.hidden = true; vazia.hidden = true; }
    else desenhar();
    // com a sacola entregue por quem chamou, a releitura em /cart.js confere o formato e os descontos sem piscar aviso
    recarregar(!!c);
    if (aberta) return;
    // logo depois de adicionar, o produto.js ja tocou "guardar"; nos outros casos, o som de abrir menu
    if (!c) Som.tocar("menu");
    aberta = true;
    clearTimeout(tempoFechar);
    gaveta.hidden = false;
    fundo.hidden = false;
    void gaveta.offsetWidth; // o navegador precisa ver a gaveta fora da tela antes de deslizar
    gaveta.classList.add("aberta");
    fundo.classList.add("aberto");
    document.documentElement.classList.add("gaveta-aberta");
    gaveta.focus({ preventScroll: true });
  }
  function fechar() {
    if (!aberta) return;
    aberta = false;
    gaveta.classList.remove("aberta");
    fundo.classList.remove("aberto");
    document.documentElement.classList.remove("gaveta-aberta");
    tempoFechar = setTimeout(function () { gaveta.hidden = true; fundo.hidden = true; }, 220);
    if (origem && origem.focus && document.documentElement.contains(origem)) origem.focus({ preventScroll: true });
    origem = null;
  }
  SK8.abrirGaveta = abrir;
  SK8.fecharGaveta = fechar;
  SK8.recarregarGaveta = recarregar;

  $$("[data-gaveta-fechar]", gaveta).forEach(function (b) {
    b.addEventListener("click", function () { Som.tocar("voltar"); fechar(); });
  });
  fundo.addEventListener("click", function () { Som.tocar("voltar"); fechar(); });

  // icone da sacola no HUD: abre a gaveta; clique com Ctrl, Shift ou botao do meio segue para /cart
  $$("a[data-sacola]").forEach(function (a) {
    a.setAttribute("aria-haspopup", "dialog");
    a.setAttribute("aria-controls", "gaveta");
    ["pointerenter", "touchstart", "focus"].forEach(function (ev) {
      a.addEventListener(ev, function () { if (!sacola) buscar().then(desenhar).catch(function () {}); }, { passive: true, once: true });
    });
    a.addEventListener("click", function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      e.preventDefault();
      abrir(null, a);
    });
  });

  // teclado com a gaveta aberta: Esc fecha, Tab e setas andam so dentro dela
  var SETAS = { ArrowUp: -1, ArrowLeft: -1, ArrowDown: 1, ArrowRight: 1 };
  document.addEventListener("keydown", function (e) {
    if (!aberta) return;
    if (e.key === "Escape") {
      e.preventDefault(); e.stopPropagation();
      Som.tocar("voltar");
      fechar();
      return;
    }
    var passo = e.key === "Tab" ? (e.shiftKey ? -1 : 1) : SETAS[e.key];
    if (!passo || e.altKey || e.metaKey || e.ctrlKey) return;
    var itens = focaveis();
    if (!itens.length) return;
    var i = itens.indexOf(document.activeElement);
    var proximo = i < 0 ? (passo > 0 ? itens[0] : itens[itens.length - 1]) : itens[(i + passo + itens.length) % itens.length];
    e.preventDefault();
    e.stopPropagation();
    proximo.focus();
    if (e.key !== "Tab") { document.documentElement.classList.add("usando-teclado"); Som.tocar("mover"); }
  }, true);
  // foco que escapar (clique, leitor de tela) volta para dentro
  document.addEventListener("focusin", function (e) {
    if (aberta && !gaveta.contains(e.target)) { var f = focaveis()[0]; (f || gaveta).focus({ preventScroll: true }); }
  });

  // ------------------------------------------------------------------ quantidade e remover
  // O item e achado pela linha (1, 2, ...) e pela variante, nunca pela chave: com o Niver ativo a
  // chave muda a cada alteracao. Depois do change.js a sacola e relida em /cart.js, porque o corpo
  // do change.js traz os descontos em outro formato.
  lista.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qtd], [data-remover]");
    if (!b || ocupado) return;
    var item = b.closest("[data-linha]");
    if (!item) return;
    var numero = Number(item.getAttribute("data-linha")), variante = item.getAttribute("data-variante");
    var atual = Number(item.getAttribute("data-qtd-atual")) || 0;
    var remover = b.hasAttribute("data-remover");
    var nova = remover ? 0 : Math.max(0, atual + Number(b.getAttribute("data-qtd")));
    var foco = remover || nova === 0 ? null : "[data-qtd='" + b.getAttribute("data-qtd") + "']";
    var posicao = numero - 1;
    Som.tocar(nova < atual ? "voltar" : "mover");
    ocupado = true;
    gaveta.classList.add("ocupada");
    lista.setAttribute("aria-busy", "true");
    mostrarAviso("");
    fetch(rotas.sacola + "/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: numero, quantity: nova })
    }).then(function (r) {
      if (!r.ok) { var falha = new Error("sacola"); falha.status = r.status; throw falha; }
      return lerSacola();
    }).then(function (c) {
      desenhar(c);
      if (SK8.atualizarSacola) SK8.atualizarSacola(c.item_count);
      if (nova > atual) {
        var tem = (c.items || []).filter(function (it) { return String(it.variant_id) === variante; }).reduce(function (s, it) { return s + it.quantity; }, 0);
        if (tem < nova) mostrarAviso("Não há mais unidades deste tamanho em estoque.");
      }
    }).catch(function (falha) {
      Som.tocar("erro");
      mostrarAviso(falha && falha.status === 422
        ? "Não há mais unidades deste tamanho em estoque."
        : "Não foi possível atualizar a sacola. Verifique a sua conexão e tente novamente.");
      return lerSacola().then(function (c) {
        desenhar(c);
        if (SK8.atualizarSacola) SK8.atualizarSacola(c.item_count);
      }).catch(function () {});
    }).then(function () {
      ocupado = false;
      gaveta.classList.remove("ocupada");
      lista.removeAttribute("aria-busy");
      // devolve o foco para o mesmo controle (ou para o item de baixo, se o item saiu)
      var alvo = null;
      var mesma = $$("[data-variante]", lista).filter(function (l) { return l.getAttribute("data-variante") === variante; })[0];
      if (mesma && foco) alvo = $(foco, mesma);
      if (!alvo) { var linhas = $$("[data-linha]", lista); var l = linhas[Math.min(posicao, linhas.length - 1)]; alvo = l ? $("[data-remover]", l) : null; }
      if (aberta) (alvo || focaveis()[0] || gaveta).focus({ preventScroll: true });
    });
  });

  // voltar do pagamento pelo navegador devolve a pagina da memoria: a sacola pode ter mudado
  window.addEventListener("pageshow", function (e) { if (e.persisted && (aberta || sacola)) recarregar(); });

  window.SK8 = SK8;
})();
